// extracted by mini-css-extract-plugin
export default {"main":"Home_main__jCBBn","leftBg":"Home_leftBg__tlFyV","rightBg":"Home_rightBg__gTv51","rightBgMobile":"Home_rightBgMobile__wk7uW","routes":"Home_routes__KvE3N"};